// 统一的文献上传组件入口
export { PaperUpload } from "./ui/PaperUpload";
export type { PaperUploadProps, PaperUploadVariant, PaperUploadRef } from "./ui/PaperUpload";

// 其他导出
export { UploadProgressPanel as PaperUploadProgressPanel } from "./ui/UploadProgressPanel";
export { useUpload as usePaperUpload } from "./hooks/useUpload";

